import { render } from "./Landing.vue?vue&type=template&id=0f713e44"
import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Landing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f713e44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f713e44', __exports__)) {
    api.reload('0f713e44', __exports__)
  }
  
  module.hot.accept("./Landing.vue?vue&type=template&id=0f713e44", () => {
    api.rerender('0f713e44', render)
  })

}


export default __exports__